/**
 * Which operators a column type offers (CT-5193).
 *
 * The matrix lives here rather than in JSX conditionals, because the bug this
 * prevents — a numeric column offering `contains`, or a text column offering
 * `greater than` — is exactly what a chain of inline ternaries produces once a
 * fourth type is added.
 *
 * The text set is the prototype's, verbatim and in its order.
 *
 * `greater_or_equal` and `less_or_equal` are not decoration. `between` has no
 * operator on the wire, so `buildWidgetPayload` sends a range as those two —
 * and a row that comes back from the backend has to land on an operator this
 * select knows, or it reopens empty.
 */
export const FILTER_OPERATORS_BY_TYPE = Object.freeze({
  text: Object.freeze(['equals', 'not_equals', 'contains', 'starts_with', 'is_empty', 'is_not_empty']),
  number: Object.freeze(['equals', 'not_equals', 'greater_than', 'greater_or_equal', 'less_than', 'less_or_equal', 'between', 'is_empty', 'is_not_empty']),
  date: Object.freeze(['equals', 'not_equals', 'greater_than', 'greater_or_equal', 'less_than', 'less_or_equal', 'between', 'is_empty', 'is_not_empty']),
  boolean: Object.freeze(['equals', 'is_empty', 'is_not_empty']),
});

/** Operators that take no value, so the value control is not rendered. */
export const OPERATORS_WITHOUT_VALUE = Object.freeze(['is_empty', 'is_not_empty']);

/** Operators that take two values (a range). */
export const OPERATORS_WITH_RANGE = Object.freeze(['between']);

/** i18n key for an operator label. */
export const operatorLabelKey = (operator) => `widgetBuilder.filters.operators.${operator}`;

/** Operators available for a column type; `[]` when the type is unknown. */
export const operatorsForType = (type) => FILTER_OPERATORS_BY_TYPE[type] ?? [];

export default FILTER_OPERATORS_BY_TYPE;
